import * as React from 'react';
import * as styles from './TourPlaceholder.css';
import { ArticleHeading4, ArticleParagraph1, Button, Icon3DPlan24, Responsive } from '@cian/ui-kit';

interface ITourPlaceholderProps {
  src?: string;
  onClick?(): void;
}

export const TourPlaceholder: React.FC<ITourPlaceholderProps> = ({ src, onClick }) => {
  return (
    <div className={styles['container']} onClick={onClick}>
      {src && <img className={styles['img']} src={src} />}
      <div className={styles['content']}>
        <Responsive desktop>
          <div className={styles['icon-desktop']} />
          <div className={styles['text-desktop']}>
            <ArticleParagraph1 color="white_100">
              Погуляйте по дому,
              <br />
              чтобы оценить планировку
            </ArticleParagraph1>
          </div>
          <Button theme="fill_white_primary" size="XS">
            Погулять по дому
          </Button>
        </Responsive>
        <Responsive tablet phone>
          <div className={styles['icon']}>
            <Icon3DPlan24 color="white_100" />
          </div>
          <ArticleHeading4 color="white_100">Посмотреть в 3D</ArticleHeading4>
        </Responsive>
      </div>
    </div>
  );
};
